import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { FC, useEffect, useState } from 'react';

const EMPTY_VALUE = '';

interface CustomSingleSelectEditProps extends GridRenderEditCellParams {
    valueOptions?: string[];
}

const CustomSingleSelectEdit: FC<CustomSingleSelectEditProps> = (props) => {
    const { api, field, id, value, hasFocus, valueOptions = [] } = props;
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (hasFocus) {
            const timer = setTimeout(() => {
                setOpen(true);
            }, 0);

            return () => {
                clearTimeout(timer);
            };
        }

        return undefined;
    }, [hasFocus]);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const newValue = event.target.value as string;
        api.setEditCellValue({ id, field, value: newValue });
        setOpen(false);
        setTimeout(() => {
            api.stopCellEditMode({ id, field });
        }, 0);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <FormControl fullWidth variant="standard">
            <Select
                value={value === EMPTY_VALUE ? '' : value}
                onChange={handleChange}
                onClose={handleClose}
                open={open}
                autoFocus={hasFocus}
                sx={{
                    '& .MuiSelect-select': {
                        padding: '8px 16px',
                        textAlign: 'right',
                        display: 'flex',
                        justifyContent: 'flex-end',
                    },
                }}
            >
                {valueOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CustomSingleSelectEdit;
